import { createContext, useState, useEffect } from 'react';
import { RaceClass } from '../constants/Regulation';

const StartNumbersContext = createContext();

const StartNumbersContextProvider = ({ children, startList, availableRaceClasses, racingNumberClassIntervals }) => {
  const [startNumberGroups, setStartNumberGroups] = useState([]);
  const [isFormValid, setIsFormValid] = useState(true);

  useEffect(() => {
    if (racingNumberClassIntervals && racingNumberClassIntervals.intervals && startList) {
      const mappedStartNumberGroups = racingNumberClassIntervals.intervals.map((interval) => {
        const raceClasses = interval.raceClasses.map((raceClassId) => {
          // Find the RaceClass object based on the id
          const raceClassObject = Object.values(RaceClass).find((rc) => rc.Id === raceClassId);
          return raceClassObject || null; // Handle the case when a id is not found
        });

        // Filter participants based on raceClasses in the interval
        const participantsInGroup = startList.filter((participant) => {
          return raceClasses.map((rc) => rc.Id).includes(participant.raceClassString)
        });

        return {
          id: Math.round(Math.random() * Number.MAX_SAFE_INTEGER),
          raceClasses: raceClasses,
          startNumber: interval.startingRacingNumber,
          participantsCount: participantsInGroup.length,
        };
      });

      setStartNumberGroups(mappedStartNumberGroups);
    }
  }, [racingNumberClassIntervals, startList]);


  const checkFormValidity = () => {
    const isValid = startNumberGroups.every((group, index) => {
      const aboveRowValue = index > 0 ? startNumberGroups[index - 1].startNumber : -Infinity;
      const aboveRowParticipantsCount = index > 0 ? startNumberGroups[index - 1].participantsCount : -Infinity;
      return group.startNumber > 0 && group.startNumber > aboveRowValue + aboveRowParticipantsCount;
    });

    setIsFormValid(isValid);
  };

  const addClass = (id, raceClass, participantsCount) => {
    const group = startNumberGroups.find((group) => group.id === id);
    group.raceClasses = [...group.raceClasses, raceClass];
    group.participantsCount = participantsCount;
    setStartNumberGroups([...startNumberGroups]);
  };

  const removeClass = (id, raceClass) => {
    const group = startNumberGroups.find((group) => group.id === id);
    group.raceClasses = group.raceClasses.filter(
      (rc) => rc.Id !== raceClass.Id
    );
    setStartNumberGroups([...startNumberGroups]);
  };

  const updateStartNumber = (id, startNumber) => {
    const group = startNumberGroups.find((group) => group.id === id);
    group.startNumber = Number(startNumber);
    setStartNumberGroups([...startNumberGroups]);
    checkFormValidity();
  };

  const addStartNumberGroup = () => {
    const lastNumber = startNumberGroups.at(-1)?.startNumber;

    startNumberGroups.push({
      id: Math.round(Math.random() * Number.MAX_SAFE_INTEGER),
      raceClasses: [],
      startNumber: lastNumber ? lastNumber + 100 : 1,
    });
    setStartNumberGroups([...startNumberGroups]);
  };

  const removeStartNumberGroup = (id) => {
    const filtered = startNumberGroups.filter((group) => group.id !== id);
    setStartNumberGroups(filtered);
  };

  return (
    <StartNumbersContext.Provider
      value={{
        startNumberGroups,
        setStartNumberGroups,
        addClass,
        removeClass,
        updateStartNumber,
        addStartNumberGroup,
        removeStartNumberGroup,
        startList,
        isFormValid,
        availableRaceClasses,
        racingNumberClassIntervals
      }}
    >
      {children}
    </StartNumbersContext.Provider>
  );
};

export { StartNumbersContext as default, StartNumbersContextProvider };
